import {ThunkKit} from 'redux-thunk-kit';
import thunkApiConfig from '~/config/thunk-api-config';

class MainThunk extends ThunkKit {}

export const thunk = new MainThunk(thunkApiConfig);
